// @flow
import type { User } from '../domain/User';
import {
  BEGIN_SESSION,
  CLOSE_SESSION,
  RENEW_SESSION,
  RENEW_SESSION_SUCCESS,
  RENEW_SESSION_FAILED,
  RETRIEVE_NO_SESSION,
  UPDATE_USER,
} from '../actions/sessionActions';

export type SessionState = {
  token: string,
  user: ?User,
  isAuthenticated: boolean,
  isRenewing: boolean,
  error: ?Object,
  isFetched: boolean
};

const INITIAL_STATE: SessionState = {
  token: '',
  user: undefined,
  isAuthenticated: false,
  isFetched: false,
  isRenewing: false,
  error: undefined,
};

export default (state: SessionState = INITIAL_STATE, action: any): SessionState => {
  switch (action.type) {
    case BEGIN_SESSION:
      return {
        ...state,
        token: action.token,
        user: action.user,
        isAuthenticated: true,
        isFetched: true,
        isRenewing: false,
      };
    case CLOSE_SESSION:
      return {
        ...state,
        isAuthenticated: false,
        token: '',
        user: undefined,
      };
    case RENEW_SESSION:
      return {
        ...state,
        isRenewing: true,
        isFetched: true,
      };
    case RENEW_SESSION_SUCCESS:
      return {
        ...state,
        token: action.token,
        isRenewing: false,
        isFetched: true,
      };
    case RENEW_SESSION_FAILED:
      return {
        ...state,
        isRenewing: false,
        isFetched: true,
      };
    case RETRIEVE_NO_SESSION:
      return {
        ...state,
        isFetched: true,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.updatedUser,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/advertisers/modules/authentication/reducers/sessionReducer.js